export const LIMIT = 30

const FooterLinksObj =
{
    "TERMS_AND_CONDITIONS": {
        name: "Terms & Conditions",
        to: "/terms"
    },
    "PRIVACY_POLICY": {
        name: "Privacy Policy",
        to: "/privacy-policy"
    }
}

export const FooterLinks = Object.entries(FooterLinksObj).map(([key, value]) => ({
    id: key,
    name: value.name,
    to: value.to
}))

export { FooterLinksObj }

//  [
//     {
//         id: "TERMS_AND_CONDITIONS",
//         name: "Terms & Conditions",
//         to: "/terms"
//     },
//     {
//         id: "PRIVACY_POLICY",
//         name: "Privacy Policy",
//         to: "/privacy-policy"
//     }
// ];